module.exports = __webpack_public_path__ + "img/director-with-dollar.08dcdefb.svg";